import i18n from '../language/i18n';

const {t} = i18n.global;
const routes =
    [
        {
            path: '/@:name(.*?)',
            name: 'profile-by-name',
            component: () => import(/* webpackChunkName: "/dyn/directory" */ '#/profile/index'),
        },

        {
            path: '/profile/:id',
            name: 'profile',
            component: () => import(/* webpackChunkName: "/dyn/directory" */ '#/profile/index'),
        },
        {
            path: '/escorts/:country([a-z-]+)/:place([a-z0-9-]+)?',
            name: 'directory-all',
            component: () => import(/* webpackChunkName: "/dyn/directory" */ '#/directory/index'),
            meta: {
                filter: 'all',
                topNav: 'container-fluid'
            }
        },
        {
            path: '/all/:country([a-z-]+)/:place([a-z0-9-]+)?',

            redirect: to => {
                const {hash, params, query} = to
                if (params.country && !params.place) {
                    return '/escorts/' + params.country;
                }
                return `/escorts/${params.country}/${params.place}`
            }


        },
        {
            path: '/trans/:country([a-z-]+)/:place([a-z0-9-]+)?',
            name: 'directory-ts',
            component: () => import(/* webpackChunkName: "/dyn/directory" */  '#/directory/index'),
            meta: {
                filter: 'trans',
                topNav: 'container-fluid'
            }
        },
        {
            path: '/countries',
            name: 'all-countries',
            component: () => import(/* webpackChunkName: "/dyn/directory" */  '#/directory/index'),
            meta: {
                filter: 'countries',
                topNav: 'container-fluid',
            }
        },
        {
            path: '/dom/:country([a-z-]+)/:place([a-z0-9-]+)?',
            name: 'directory-dom',
            component: () => import(/* webpackChunkName: "/dyn/directory" */  '#/directory/index'),
            meta: {
                filter: 'dom',
                topNav: 'container-fluid'
            }
        },

        {
            path: '/male/:country([a-z-]+)/:place([a-z0-9-]+)?',
            name: 'directory-male',
            component: () => import(/* webpackChunkName: "/dyn/directory" */  '#/directory/index'),
            meta: {
                filter: 'male',
                topNav: 'container-fluid'
            }
        },

        {
            path: '/bookmarks',
            name: 'bookmarks',
            component: () => import(/* webpackChunkName: "/dyn/directory" */  '#/directory/bookmarks'),
            meta: {
                topNav: 'container-fluid',
                filter: 'bookmarks',
            }
        },

        {
            path: '/female/:country([a-z-]+)/:place([a-z0-9-]+)?',
            name: 'directory-female',
            component: () => import(/* webpackChunkName: "/dyn/directory" */ '#/directory/index'),
            meta: {
                filter: 'female',
                topNav: 'container-fluid'
            }
        },
        {
            path: '/search',
            name: 'search',
            component: () => import(/* webpackChunkName: "/dyn/directory" */ '#/search/index'),
            meta: {
                topNav: 'container-fluid'
            }
        },

        {
            path: '/page-not-found',
            name: 'page-not-found',
            component: () => import(/* webpackChunkName: "/dyn/settings" */ '#/pages/page-not-found'),
            meta: {}
        },
        {
            path: '/:pathMatch(.*)*',
            redirect: {name: 'page-not-found'},  
            meta: {
                mNav: true
            }
        }

    ]
export default routes
